import classNames from 'classnames';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = exact({
  blockName: PropTypes.string,
  fieldName: PropTypes.string,
  fieldValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  isValid: PropTypes.bool,
  modifier: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      text: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    })
  ).isRequired,
  placeholderText: PropTypes.string,
  overlay: PropTypes.object,
});

const defaultProps = {
  blockName: null,
  fieldName: null,
  fieldValue: '',
  isDisabled: false,
  isInvalid: false,
  isRequired: false,
  isValid: false,
  modifier: 'ghost',
  placeholderText: null,
};

function Dropdown(props) {
  const dropdownClasses = classNames(props.blockName, 'Dropdown', `Dropdown-${props.modifier}`, {
    disabled: props.isDisabled,
    invalid: props.isInvalid,
    valid: props.isValid,
  });

  return (
    <div className={dropdownClasses}>
      {props.overlay && <div className="Dropdown_overlay">{props.overlay}</div>}
      <select
        name={props.fieldName}
        onChange={props.handleChange}
        value={props.fieldValue}
        disabled={props.isDisabled}
        required={props.isRequired}
        className="Dropdown_select"
      >
        {props.placeholderText && (
          <option value="" disabled>
            {`${props.placeholderText}${props.isRequired ? '*' : ''}`}
          </option>
        )}
        {props.options.map((option) => (
          <option key={option.value} value={option.value} disabled={!!option.disabled}>
            {option.text}
          </option>
        ))}
      </select>
    </div>
  );
}

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;

export default Dropdown;
